import { Text as e } from "../Typography/Typography.js";
import "../Typography/index.js";
import { useGetRegisteredMenuItems as t } from "../ApplicationMenu/useGetRegisteredMenuItems.js";
import { DOWNLOAD_SUBMENU_ID as n } from "../ApplicationMenu/constants.js";
import "../ApplicationMenu/index.js";
import r from "./DownloadSelectButton.module.js";
import { c as i } from "react/compiler-runtime";
import { Button as a } from "@jetbrains/ring-ui-built/components/button/button";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import c from "@jetbrains/icons/download";
import l from "@jetbrains/icons/warning";
import u from "@jetbrains/ring-ui-built/components/dropdown-menu/dropdown-menu";
import d from "@jetbrains/ring-ui-built/components/icon/icon";
import { Type as f } from "@jetbrains/ring-ui-built/components/list/consts";
//#region src/components/DownloadSelectButton/DownloadSelectButton.tsx
var p = 10, m = {
	icon: c,
	inline: !1,
	title: "Download SARIF file",
	"aria-label": "Download SARIF file"
}, h = (e) => {
	let r = i(9), { onClick: s } = e, c = t(n);
	if (!c?.length) {
		let e;
		return r[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ o(a, {
			...m,
			loader: !0,
			"data-test": "download-sarif-file-button-loading"
		}), r[0] = e) : e = r[0], e;
	}
	let l;
	r[1] === c ? l = r[2] : (l = c.map(g), r[1] = c, r[2] = l);
	let d = l, f;
	r[3] === s ? f = r[4] : (f = /* @__PURE__ */ o(a, {
		...m,
		onClick: s,
		"data-test": "download-sarif-file-button"
	}), r[3] = s, r[4] = f);
	let p;
	r[5] === Symbol.for("react.memo_cache_sentinel") ? (p = {
		top: 4,
		activateFirstItem: !1,
		"data-test": "download-sarif-file-dropdown-popup"
	}, r[5] = p) : p = r[5];
	let h;
	return r[6] !== d || r[7] !== f ? (h = /* @__PURE__ */ o(u, {
		anchor: f,
		menuProps: p,
		data: d
	}), r[6] = d, r[7] = f, r[8] = h) : h = r[8], h;
};
function g(t) {
	let { key: n, label: i, description: a, onClick: c } = t;
	return {
		key: n,
		rgItemType: f.CUSTOM,
		onClick: c,
		template: /* @__PURE__ */ s("span", { children: [i, a && /* @__PURE__ */ s("div", {
			className: r.errorDescriptionContainer,
			children: [/* @__PURE__ */ o(d, {
				size: p,
				className: r.errorDescriptionIcon,
				glyph: l
			}), /* @__PURE__ */ o(e, {
				small: !0,
				className: r.errorDescription,
				children: a
			})]
		})] })
	};
}
//#endregion
export { h as DownloadSelectButton };
